import * as React from 'react';
import {alpha, styled} from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import PollIcon from '@mui/icons-material/Poll';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {getHastags} from '../utils/helper';
import {useNavigate} from 'react-router-dom';
import {URLS} from '../constants/appConstants';
import {getCoinsIcon} from './common/simpleComponents';
import Button from '@mui/material/Button';
import {faker} from '@faker-js/faker';
import AnimatedCoins from './coins/AnimatedCoins';

const Search = styled('div')(({theme}) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));



export default function PrimarySearchAppBar({currentBalance}) {
  const [searchTerm, setSearchTerm] = React.useState('');
  const [num, setNum] = React.useState(331231);

  const navigate = useNavigate();
  const handleKeyDown = (event) => {
    event.preventDefault()
    // setKeycode(event.keyCode)
    setSearchTerm(event.detail.value)
    if ((event.keyCode === 13) || (searchTerm === 'aaa')) {
      navigate(URLS.SEARCH)
    }
  }

  return (
    <Box sx={{
      // flexGrow: 1,
      // mb: 2
    }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{mr: 2}}
          >
            <PollIcon/>
          </IconButton>
          <Search>
            <Autocomplete
              id="search"
              freeSolo
              options={getHastags()}
              renderInput={(params) => (
                <TextField {...params} label="Search" size={'small'}/>
              )}
              onKeyDown={handleKeyDown}
            />
          </Search>
          <Button id='home-get-icon' sx={{color: 'white'}} onClick={() => navigate(URLS.COINS_DASHBOARD)}>
            <AnimatedCoins currentBalance={currentBalance}/>
            {getCoinsIcon()}
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
